export default [
  'CartAPIService', 'CampaignService', 'ErrorHandler',
  class UpsellCartService {
    constructor (cartAPI, campaignService, errorHandler) {
      this._cartAPI = cartAPI;
      this._campaignService = campaignService;
      this._errorHandler = errorHandler;

      this._shippingState = '';
      this._shippingCountry = 'US';

      this._originalCampaignId = null;
      this._campaign = {};
      this._contents = [];
      this.totals = {};
    }

    initAmazon (refID, orderID, upsellProduct) {
      if (this.paypal) return false;
      this.amazon = {
        referenceID: refID,
        orderID: orderID
      };
      this._contents = upsellProduct;
      return this.getAmazonTotals();
    }

    initPaypal (publicName, campaignSlug, upsellProduct, originalCampaignId) {
      if (typeof this.amazon === 'object') return false;
      this._contents = upsellProduct;
      this._originalCampaignId = originalCampaignId;
      this.paypal = true;

      let campaignPromise = this._campaignService.getBySlug(publicName, campaignSlug);
      campaignPromise.then((res) => this._campaign = res.campaign)
      return campaignPromise;
    }

    setCountry(country, state = null) {
      this._shippingCountry = country;
      this._shippingState = state;
      return this._getTotals();
    }

    contents () {
      return this._contents;
    }

    getTotals () {
      this._getTotals();
      return this.totals;
    }

    _getTotals () {
      if (typeof this.amazon === 'object') return this.getAmazonTotals();
      else if (this.paypal) return this._getPaypalTotals();
      else return this.totals;
    }

    getAmazonTotals () {
      let p = this._cartAPI.getAmazonTotal(this.amazon.referenceID, this.amazon.orderID);

      p.then((cartData) => {
        this.totals.discount = cartData['discount_amount'];
        this.totals.checkout = cartData['sub_total'];
        this.totals.shipping = cartData['shipping_cost'];
        this.totals.tax      = cartData['sales_tax'];
        this.totals.grand    = cartData['grand_total'];
      });

      return p;
    }

    _getPaypalTotals () {
      let p = this._cartAPI.getTotal(this._campaign.id, null, this._shippingState, this._shippingCountry, this._contents, this._originalCampaignId);

      p.then((cartData) => {
        this.totals.discount = cartData['discount_amount'];
        this.totals.checkout = cartData['sub_total'];
        this.totals.shipping = cartData['shipping_cost'];
        this.totals.tax      = cartData['sales_tax'];
        this.totals.grand    = cartData['grand_total'];
      });

      return p;
    }

    processAmazonPaymentCart (id, orderReferenceID) {
      return this._cartAPI.processAmazonPayment(id, orderReferenceID)
        .catch(() => this._errorHandler.throwError('Amazon Payment Processing', 'Unable to process payment at this time.'));
    }

    _processPaypalPayment () {

    }
  }
];



// WEBPACK FOOTER //
// ./source/client/data-providers/upsell-cart-service.js